import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/unit-types`;

const unitTypesService = {
  getAll: (facilityId, params) =>
    apiClient.get(`${base(facilityId)}/`, { params }),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) =>
    apiClient.put(`${base(facilityId)}/${id}`, data),
  delete: (facilityId, id) => apiClient.delete(`${base(facilityId)}/${id}`),
};

export default unitTypesService;
